import Chart from "pages/Chart";
import ControlHistory from "pages/ControlHistory";
import DetailHistory from "pages/DetailHistory";
import BatchControl from "pages/Home/BatchControl";
import Home from "pages/Home/Home";
import HomeMap from "pages/Home/HomeMap";
import Login from "pages/Login";
import Logout from "pages/Logout";

import ItemSetting from "pages/SMS/ItemSetting";
import ItemSettingAddPage from "pages/SMS/ItemSetting/ItemSettingAddPage";
import ItemSettingEditPage from "pages/SMS/ItemSetting/ItemSettingEditPage";
import ReceiveSetting from "pages/SMS/ReceiveSetting";
import ReceiveSettingAddPage from "pages/SMS/ReceiveSetting/ReceiveSettingAddPage";
import ReceiveSettingEditPage from "pages/SMS/ReceiveSetting/ReceiveSettingEditPage";
import SendList from "pages/SMS/SendList";
import MenuTestingSms from "pages/SMS/SendTestingSms";

import Manual from "pages/Manual";
import MyPage from "pages/MyPage";

import AdminManual from "pages/Admin/AdminManual";
import AdminManualAddPage from "pages/Admin/AdminManual/AdminManualAddPage";
import AdminManualEditPage from "pages/Admin/AdminManual/AdminManualEditPage";
import Changes from "pages/Admin/Changes";
import Device from "pages/Admin/Device";
import AdminDeviceAddPage from "pages/Admin/Device/AdminDeviceAddPage";
import AdminDeviceEditPage from "pages/Admin/Device/AdminDeviceEditPage";
import AdminGroup from "pages/Admin/Group";
import AdminGroupAddPage from "pages/Admin/Group/AdminGroupAddPage";
import AdminGroupEditPage from "pages/Admin/Group/AdminGroupEditPage";
import Library from "pages/Admin/Library";
import AdminLibraryAddPage from "pages/Admin/Library/AdminLibraryAddPage";
import AdminLibraryEditPage from "pages/Admin/Library/AdminLibraryEditPage";
import Site from "pages/Admin/Site";
import AdminSiteAddPage from "pages/Admin/Site/AdminSiteAddPage";
import AdminSiteEditPage from "pages/Admin/Site/AdminSiteEditPage";
import SiteEdit from "pages/Admin/SiteEdit";
import AdminSiteEditAddPage from "pages/Admin/SiteEdit/components/SiteEditAddForm";
import AdminSiteEditEditPage from "pages/Admin/SiteEdit/components/SiteEditForm";
import User from "pages/Admin/User";
import AdminUserAddPage from "pages/Admin/User/AdminUserAddPage";
import AdminUserEditPage from "pages/Admin/User/AdminUserEditPage";
import HighwaySearch from "pages/Highway";

import NotFound from "pages/NotFound";

import { Navigate, Route, Routes } from "react-router-dom";

import { userState } from "pages/Login/atom/userState";
import { useRecoilState } from "recoil";

// Level 별 권한
// 전체관리자 - Level 0
// 그룹관리자 - Level 1
// 일반사용자 - Level 2

const PageRoutes = () => {
  const [user] = useRecoilState(userState);
  const level = Number(user?.fn_level);
  const adminLevel = [0].includes(level);

  return (
    <Routes>
      {/* 공용 */}
      <Route path="/logout" element={<Logout />} />
      <Route path="/" element={ user === false ? <Login /> : <Navigate to="/home_map" replace /> } />

      {/* 공통 사용자 메뉴 */}
      {user !== false && (
        <>
          <Route path="/home_map" element={<HomeMap />} />
          <Route path="/home" element={<Home />} />
          <Route path="/batch_control" element={<BatchControl />} />
          <Route path="/chart" element={<Chart />} />
          <Route path="/detail_history" element={<DetailHistory />} />
          <Route path="/control_history" element={<ControlHistory />} />
          <Route path="/manual" element={<Manual />} />
          <Route path="/mypage" element={<MyPage />} />
          <Route path="/sms/list" element={<SendList />} />
          <Route path="/sms/receive" element={<ReceiveSetting />} />
          <Route path="/sms/receive/add" element={<ReceiveSettingAddPage />} />
          <Route path="/sms/receive/:id" element={<ReceiveSettingEditPage />} />
        </>
      )}

      {adminLevel && (
        <>
          <Route path="/sms/test" element={<MenuTestingSms />} />
          <Route path="/sms/item" element={<ItemSetting />} />
          <Route path="/sms/item/add" element={<ItemSettingAddPage />} />
          <Route path="/sms/item/:id" element={<ItemSettingEditPage />} />

          <Route path="/admin/user" element={<User />} />
          <Route path="/admin/user/add" element={<AdminUserAddPage />} />
          <Route path="/admin/user/:id" element={<AdminUserEditPage />} />

          <Route path="/admin/group" element={<AdminGroup />} />
          <Route path="/admin/group/add" element={<AdminGroupAddPage />} />
          <Route path="/admin/group/:id" element={<AdminGroupEditPage />} />

          <Route path="/admin/site" element={<Site />} />
          <Route path="/admin/site/add" element={<AdminSiteAddPage />} />
          <Route path="/admin/site/:id" element={<AdminSiteEditPage />} />

          <Route path="/admin/library" element={<Library />} />
          <Route path="/admin/library/add" element={<AdminLibraryAddPage />} />
          <Route path="/admin/library/:id" element={<AdminLibraryEditPage />} />

          <Route path="/admin/device" element={<Device />} />
          <Route path="/admin/device/add" element={<AdminDeviceAddPage />} />
          <Route path="/admin/device/:id" element={<AdminDeviceEditPage />} />

          <Route path="/admin/manual" element={<AdminManual />} />
          <Route path="/admin/manual/add" element={<AdminManualAddPage />} />
          <Route path="/admin/manual/:id" element={<AdminManualEditPage />} />

          <Route path="/admin/site_edit" element={<SiteEdit />} />
          <Route path="/admin/site_edit/add" element={<AdminSiteEditAddPage />} />
          <Route path="/admin/site_edit/:id" element={<AdminSiteEditEditPage />} />
          <Route path="/admin/change_log" element={<Changes />} />

          <Route path="/highway" element={<HighwaySearch />} />
        </>
      )}

      {level === 1 && (
        <>
          <Route path="/sms/test" element={<MenuTestingSms />} />
          <Route path="/sms/item" element={<ItemSetting />} />
          <Route path="/sms/item/add" element={<ItemSettingAddPage />} />
          <Route path="/sms/item/:id" element={<ItemSettingEditPage />} />

          <Route path="/admin/user" element={<User />} />
          <Route path="/admin/user/add" element={<AdminUserAddPage />} />
          <Route path="/admin/user/:id" element={<AdminUserEditPage />} />

          <Route path="/admin/site" element={<Site />} />
          <Route path="/admin/site/add" element={<AdminSiteAddPage />} />
          <Route path="/admin/site/:id" element={<AdminSiteEditPage />} />

          <Route path="/admin/library" element={<Library />} />
          <Route path="/admin/library/add" element={<AdminLibraryAddPage />} />
          <Route path="/admin/library/:id" element={<AdminLibraryEditPage />} />

          <Route path="/admin/device" element={<Device />} />
          <Route path="/admin/device/add" element={<AdminDeviceAddPage />} />
          <Route path="/admin/device/:id" element={<AdminDeviceEditPage />} />

          <Route path="/admin/manual" element={<AdminManual />} />
          <Route path="/admin/manual/add" element={<AdminManualAddPage />} />
          <Route path="/admin/manual/:id" element={<AdminManualEditPage />} />

          <Route path="/admin/site_edit" element={<SiteEdit />} />
          <Route path="/admin/site_edit/add" element={<AdminSiteEditAddPage />} />
          <Route path="/admin/site_edit/:id" element={<AdminSiteEditEditPage />} />
        </>
      )}

      {user === false ? (
        <Route path="*" element={<Navigate to="/" replace />} />
      ) : (
        <Route path="*" element={<NotFound />} />
      )}
    </Routes>
  );
};

export default PageRoutes;
